import { PorImageRegistryModel } from 'Docker/models/porImageRegistry';

angular.module('shbdeployer.docker').controller('ImportImageController', [
  '$scope',
  '$state',
  'ImageService',
  'Notifications',
  'HttpRequestHelper',
  'Authentication',
  'ImageHelper',
  'endpoint',
  function ($scope, $state, ImageService, Notifications, HttpRequestHelper, Authentication, ImageHelper, endpoint) {
    $scope.state = {
      actionInProgress: false,
    };

    $scope.endpoint = endpoint;

    $scope.isAdmin = Authentication.isAdmin();

    $scope.formValues = {
      UploadFile: null,
      NodeName: null,
      RegistryModel: new PorImageRegistryModel(),
    };

    $scope.setPullImageValidity = setPullImageValidity;
    function setPullImageValidity(validity) {
      $scope.state.pullImageValidity = validity;
    }

    async function tagImage(id) {
      const registryModel = $scope.formValues.RegistryModel;
      if (registryModel.Image) {
        const image = ImageHelper.createImageConfigForContainer(registryModel);
        try {
          await ImageService.tagImage(id, image.fromImage);
        } catch (err) {
          Notifications.error('Ошибка', err, 'Не удалось добавить тег образу');
        }
      }
    }

    $scope.uploadImage = async function () {
      $scope.state.actionInProgress = true;

      var nodeName = $scope.formValues.NodeName;
      HttpRequestHelper.setPortainerAgentTargetHeader(nodeName);
      var file = $scope.formValues.UploadFile;
      try {
        const { data } = await ImageService.uploadImage(file);
        if (data.error) {
          Notifications.error('Ошибка', data.error, 'Не удалось загрузить образ');
        } else if (data.stream) {
          var regex = /Loaded.*?: (.*?)\n$/g;
          var imageIds = regex.exec(data.stream);
          if (imageIds && imageIds.length == 2) {
            await tagImage(imageIds[1]);
            $state.go('docker.images.image', { id: imageIds[1] }, { reload: true });
          }
          Notifications.success('Образы успешно загружены');
        } else {
          Notifications.success('Загруженный tar-архив содержит несколько образов, поэтому указанный тег не был применен.');
        }
      } catch (err) {
        Notifications.error('Ошибка', err, 'Не удалось загрузить образ');
      } finally {
        $scope.state.actionInProgress = false;
      }
    };
  },
]);
